import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const statisticsApi = factory.get("statistics");

const initialState = {
  data: {
    loading: false,
    cards: {
      total_active_user: 0,
      total_day_off_today: 0,
      total_today_users: 0,
      total_attendance: 0,
      total_vacation_days: 0,
      total_vacation_hourly: 0,
      total_department: 0,
      avg_working_hours: 0,
    },
    attendance10DaysAgo: [],
    usersDayOff: [],
    leaveApps: [],
  },
  final_accounts: {
    only_user_ids_can_show: [
      "2bb01efa-9a6a-4fac-9112-e4d81a8d65b2",
      "13247c2e-94ac-4790-8dac-0b83539ff768",
    ],
    loading: false,
    is_ready: false,
  },
};

export const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {
    setDataTable: (state, { payload }) => {
      state.data[payload.key] = payload.value;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setCards: (state, { payload }) => {
      state.data.cards = payload.data.data;
    },
    setChart: (state, { payload }) => {
      state.data.attendance10DaysAgo = payload.data.data;
    },
    setFinalAccountsStatus: (state, { payload }) => {
      state.final_accounts.is_ready = payload;
    },
  },
});

export const {
  setLoading,
  setDataTable,
  setCards,
  setChart,
  setFinalAccountsStatus,
} = statisticsSlice.actions;

export default statisticsSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("data"));

    const cardsRes = await statisticsApi.cards();
    const attendance10DaysAgoRes = await statisticsApi.attendance10DaysAgo();
    const usersDayOffRes = await statisticsApi.usersDayOff({ day: "Sunday" });
    const leaveAppsRes = await statisticsApi.leaveApps();

    dispatch(
      setDataTable({ key: "usersDayOff", value: usersDayOffRes.data.data }),
    );
    dispatch(setDataTable({ key: "leaveApps", value: leaveAppsRes.data.data }));
    dispatch(setCards(cardsRes));
    dispatch(setChart(attendance10DaysAgoRes));

    dispatch(setLoading("data"));
  } catch (err) {
    dispatch(setLoading("data"));
    throw new Error(err);
  }
};
const downloadExcel = () => async (dispatch, getState) => {
  try {
    const res = await statisticsApi.downloadExcel();
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = `final-accounts-${new Date()}.xlsx`;
    a.click();
  } catch (err) {
    // console.log(res)
    dispatch(
      showNotification({
        message: "حدث خطأ أثناء تحميل الملف",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};
const checkFinalAccountsStatus = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("final_accounts"));
    const res = await statisticsApi.checkDownloadExcelStatus();
    dispatch(setFinalAccountsStatus(res.data.data.status));
    dispatch(setLoading("final_accounts"));
  } catch (err) {
    dispatch(setLoading("final_accounts"));
    throw new Error(err);
  }
};
const importExcel = (data) => async (dispatch, getState) => {
  try {
    const formData = new FormData();
    formData.append("clients", data.clientsAttachment);
    formData.append("profits", data.profitAttachment);
    dispatch(setLoading("final_accounts"));
    const res = await statisticsApi.importExcel(formData);
    dispatch(setLoading("final_accounts"));
    dispatch(
      showNotification({
        message: "تم رفع الملف بنجاح",
        type: "success",
      }),
    );
  } catch (err) {
    dispatch(setLoading("final_accounts"));
    dispatch(
      showNotification({
        message: "حدث خطأ أثناء رفع الملف",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const Statistics = {
  getAll,
  downloadExcel,
  checkFinalAccountsStatus,
  importExcel,
};
